import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import iconFirst from '../assets/icon-first.png';
import iconInclusive from '../assets/icon-inclusive.png';
import iconProfessional from '../assets/icon-professional.png';

const CorporateSponsorship = () => {
  const tierColors = {
    sapphire: '#0F52BA',
    emerald: '#50C878',
    ruby:    '#E0115F',
    diamond: '#00A7E1',
    presenting: '#C4922A'
  };

  const checkmark = (val) => {
    if (val === true)  return <span style={{color: '#4caf50', fontWeight: 700}}>✓</span>;
    if (val === false) return <span style={{color: '#ccc'}}>—</span>;
    return <span style={{fontWeight: 600, color: 'var(--charcoal)'}}>{val}</span>;
  };

  const tableRows = [
    { label: 'Logo on sponsors page',            s: true,       em: true,       r: true,          d: true,          p: true },
    { label: 'Newsletter & social posts',         s: true,       em: true,       r: true,          d: true,          p: true },
    { label: 'Dedicated social media posts',      s: '1 post',   em: '2 posts',  r: '2 posts',     d: '4 posts',     p: '6 posts' },
    { label: 'Certificate of sponsorship',        s: true,       em: true,       r: true,          d: true,          p: true },
    { label: 'Impact reports',                    s: 'Annual',   em: 'Quarterly',r: 'Quarterly',   d: 'Quarterly',   p: 'Quarterly' },
    { label: 'Competition program logo',          s: false,      em: true,       r: true,          d: true,          p: true },
    { label: 'Event signage at venue',            s: false,      em: true,       r: true,          d: true,          p: true },
    { label: 'Complimentary tickets',             s: false,      em: '2',        r: '4',           d: '8 VIP',       p: '8 VIP' },
    { label: 'Recognition at announcements',      s: false,      em: true,       r: true,          d: true,          p: true },
    { label: 'Website homepage logo',             s: false,      em: false,      r: true,          d: true,          p: true },
    { label: 'VIP reception with dancers & staff',s: false,      em: false,      r: true,          d: true,          p: true },
    { label: 'Press release recognition',         s: false,      em: false,      r: true,          d: true,          p: true },
    { label: 'Custom award on stage',             s: false,      em: false,      r: false,         d: true,          p: true },
    { label: 'Speaking opportunity',              s: false,      em: false,      r: false,         d: true,          p: true },
    { label: 'Sponsor underprivileged dancers',   s: false,      em: false,      r: false,         d: true,          p: true },
    { label: 'Premier logo (largest size)',       s: false,      em: false,      r: false,         d: true,          p: true },
    { label: 'Exclusive networking event',        s: false,      em: false,      r: false,         d: true,          p: true },
    { label: 'Title naming rights',               s: false,      em: false,      r: false,         d: false,         p: true },
    { label: 'First logo on every asset',         s: false,      em: false,      r: false,         d: false,         p: true },
    { label: 'Dedicated homepage section',        s: false,      em: false,      r: false,         d: false,         p: true },
    { label: 'Company rep presents award on stage', s: false,    em: false,      r: false,         d: false,         p: true },
  ];

  const thStyle = (color) => ({
    padding: '0.75rem 0.5rem',
    textAlign: 'center',
    color: '#fff',
    background: color,
    fontWeight: 700,
    fontSize: '0.85rem',
    whiteSpace: 'nowrap'
  });

  const tdStyle = (i) => ({
    padding: '0.6rem 0.5rem',
    textAlign: 'center',
    fontSize: '0.85rem',
    background: i % 2 === 0 ? '#fafafa' : '#fff',
    borderBottom: '1px solid #eee'
  });

  const tdLabelStyle = (i) => ({
    padding: '0.6rem 0.75rem',
    textAlign: 'left',
    fontSize: '0.85rem',
    fontWeight: 500,
    color: 'var(--charcoal)',
    background: i % 2 === 0 ? '#fafafa' : '#fff',
    borderBottom: '1px solid #eee'
  });

  return (
    <Layout
      title="Corporate Sponsorship | Prix du Canada Ballet Competition"
      description="Partner with Prix du Canada through corporate sponsorship. Support the Canadian ballet community with recognition benefits, brand visibility, and meaningful impact."
      keywords="ballet competition sponsorship, corporate partnership ballet, dance competition sponsor Toronto, ballet arts sponsorship Canada"
    >
      {/* Hero Section */}
      <section className="elegant-hero" style={{paddingTop: '2rem', paddingBottom: '2rem'}}>
        <div className="container">
          {/* Breadcrumb Navigation */}
          <div style={{marginBottom: '3.5rem', fontSize: '0.9rem', color: 'var(--soft-gray)', textAlign: 'left'}}>
            <Link to="/" style={{color: 'var(--primary-gold)', textDecoration: 'none'}}>Home</Link>
            <span style={{margin: '0 0.5rem'}}>&gt;</span>
            <Link to="/support" style={{color: 'var(--primary-gold)', textDecoration: 'none'}}>Support</Link>
            <span style={{margin: '0 0.5rem'}}>&gt;</span>
            <span>Corporate Sponsorship</span>
          </div>

          <h1>Corporate Sponsorship</h1>
          <p style={{textAlign: 'center'}}>Partner with us to support the arts and make a lasting impact in the dance community. Your sponsorship helps bring professional stage opportunities to dancers of all backgrounds.</p>

          {/* Non-profit pursuit notice */}
          <p style={{textAlign: 'center', fontSize: '0.95rem', color: 'var(--soft-gray)', fontStyle: 'italic', marginTop: '0.5rem'}}>
            Prix du Canada is currently pursuing non-profit incorporation in Ontario as we grow our organization.
          </p>
        </div>
      </section>

      {/* Jump To Navigation */}
      <div style={{maxWidth: '700px', margin: '2.5rem auto 2.5rem', textAlign: 'left'}}>
        <div style={{fontSize: '1.1rem', color: 'var(--primary-gold)', fontWeight: '600', marginBottom: '0.3em', textAlign: 'left'}}>Jump to:</div>
        <ul style={{listStyle: 'none', paddingLeft: '0', margin: '0 0 1.2rem 0', lineHeight: '1.6', textAlign: 'left'}}>
          <li style={{marginBottom: '0.2em'}}><a href="#why-sponsor" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Why Sponsor Prix du Canada</a></li>
          <li style={{marginBottom: '0.2em'}}><a href="#sapphire" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Sapphire ($500)</a></li>
          <li style={{marginBottom: '0.2em'}}><a href="#emerald" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Emerald ($1,000)</a></li>
          <li style={{marginBottom: '0.2em'}}><a href="#ruby" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Ruby ($2,000)</a></li>
          <li style={{marginBottom: '0.2em'}}><a href="#diamond" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Diamond ($3,500)</a></li>
          <li style={{marginBottom: '0.2em'}}><a href="#presenting" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Presenting Partner ($5,000)</a></li>
          <li><a href="#contact" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Become a Sponsor</a></li>
        </ul>
      </div>

      {/* Main Content */}
      <section className="section" style={{background: 'var(--soft-cream)'}}>
        <div className="container" style={{maxWidth: '900px', textAlign: 'left'}}>

          {/* Why Sponsor Section */}
          <section id="why-sponsor" style={{marginBottom: '3rem'}}>
            <h2 style={{textAlign: 'left', color: 'var(--charcoal)'}}>Why Sponsor Prix du Canada</h2>
            <p style={{marginBottom: '1rem'}}>
              Prix du Canada is committed to making professional ballet competition accessible to all dancers, regardless of their background or experience level. We celebrate excellence while fostering inclusivity, welcoming competitive dancers, recreational adults, and everyone in between.
            </p>
            <p style={{marginBottom: '1rem'}}>
              As a corporate sponsor, you'll join us in supporting the Canadian ballet community and bringing world-class performance opportunities to dancers across Canada. Your partnership directly funds:
            </p>
            <ul style={{marginLeft: '1.5rem', marginBottom: '1.5rem'}}>
              <li style={{marginBottom: '0.5rem'}}><strong>Scholarships</strong> for dancers facing financial barriers</li>
              <li style={{marginBottom: '0.5rem'}}><strong>Professional venue and production</strong> ensuring every performance shines</li>
              <li style={{marginBottom: '0.5rem'}}><strong>Community programs and events</strong> that make ballet accessible to all</li>
              <li style={{marginBottom: '0.5rem'}}><strong>Competition resources and support</strong> for participants throughout their journey</li>
            </ul>
            <p style={{marginBottom: '1rem'}}>
              Prix du Canada's audience of families and young professionals across the GTA represents a highly engaged community making active financial, lifestyle, and cultural decisions — making this a meaningful platform for brands looking to connect with this demographic.
            </p>
            <div style={{background: 'linear-gradient(135deg, #fff9f0 0%, #faf9f7 100%)', borderLeft: '4px solid var(--primary-gold)', padding: '1.5rem', margin: '1.5rem 0', borderRadius: '8px'}}>
              <p style={{margin: 0, fontWeight: '600', color: 'var(--charcoal)', marginBottom: '0.5rem'}}>✨ Our Commitment to Transparency</p>
              <p style={{margin: 0, color: 'var(--soft-gray)'}}>
                100% of corporate sponsorships go directly to programming and supporting the Canadian ballet community. We provide detailed impact reports so you can see exactly how your contribution makes a difference.
              </p>
            </div>
          </section>

          {/* Tier Divider */}
          <div style={{borderTop: '2px solid var(--primary-gold)', margin: '3rem 0 2rem', paddingTop: '2rem'}}>
            <h2 style={{textAlign: 'center', color: 'var(--charcoal)', marginBottom: '0.5rem'}}>Sponsorship Tiers</h2>
            <p style={{textAlign: 'center', color: 'var(--soft-gray)', fontSize: '1.05rem', marginBottom: '0.75rem'}}>
              Choose the partnership level that aligns with your organization's goals and budget
            </p>
            <p style={{textAlign: 'center', fontStyle: 'italic', color: 'var(--soft-gray)', fontSize: '0.95rem', marginBottom: '2rem'}}>
              Our tiers are named after precious stones — celebrating the milestones of our dancers and inspired by Balanchine's iconic ballet, <em>Jewels</em>.
            </p>
          </div>

          {/* Comparison Table */}
          <div style={{overflowX: 'auto', marginBottom: '3rem', borderRadius: '10px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)'}}>
            <table style={{width: '100%', borderCollapse: 'collapse', minWidth: '640px'}}>
              <thead>
                <tr>
                  <th style={{padding: '0.75rem', textAlign: 'left', background: '#2c2c2c', color: '#fff', fontSize: '0.85rem', fontWeight: 700}}>Benefit</th>
                  <th style={thStyle(tierColors.sapphire)}>💙 Sapphire<br/><span style={{fontWeight: 400, fontSize: '0.8rem'}}>$500</span></th>
                  <th style={thStyle(tierColors.emerald)}>💚 Emerald<br/><span style={{fontWeight: 400, fontSize: '0.8rem'}}>$1,000</span></th>
                  <th style={thStyle(tierColors.ruby)}>❤️ Ruby<br/><span style={{fontWeight: 400, fontSize: '0.8rem'}}>$2,000</span></th>
                  <th style={thStyle(tierColors.diamond)}>💎 Diamond<br/><span style={{fontWeight: 400, fontSize: '0.8rem'}}>$3,500</span></th>
                  <th style={thStyle(tierColors.presenting)}>🍁 Presenting<br/><span style={{fontWeight: 400, fontSize: '0.8rem'}}>$5,000</span></th>
                </tr>
              </thead>
              <tbody>
                {tableRows.map((row, i) => (
                  <tr key={i}>
                    <td style={tdLabelStyle(i)}>{row.label}</td>
                    <td style={tdStyle(i)}>{checkmark(row.s)}</td>
                    <td style={tdStyle(i)}>{checkmark(row.em)}</td>
                    <td style={tdStyle(i)}>{checkmark(row.r)}</td>
                    <td style={tdStyle(i)}>{checkmark(row.d)}</td>
                    <td style={tdStyle(i)}>{checkmark(row.p)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* SAPPHIRE TIER */}
          <section id="sapphire" style={{marginBottom: '3rem'}}>
            <h3 style={{color: 'var(--charcoal)', fontWeight: 600, marginBottom: '1rem', fontSize: '1.8rem'}}>
              💙 Sapphire — $500 annually
            </h3>

            <p style={{fontWeight: '600', color: 'var(--charcoal)', marginBottom: '0.8rem'}}>Your Benefits:</p>
            <ul style={{marginLeft: '0', paddingLeft: '0', listStyle: 'none', color: '#666'}}>
              <li style={{marginBottom: '0.6rem'}}>✓ Company logo displayed on Prix du Canada sponsors page</li>
              <li style={{marginBottom: '0.6rem'}}>✓ Logo featured in monthly email newsletter and social posts</li>
              <li style={{marginBottom: '0.6rem'}}>✓ 1 dedicated social media post</li>
              <li style={{marginBottom: '0.6rem'}}>✓ Certificate of sponsorship</li>
              <li style={{marginBottom: '0.6rem'}}>✓ Annual impact report showing how your contribution supports dancers</li>
            </ul>
          </section>

          {/* EMERALD TIER */}
          <section id="emerald" style={{marginBottom: '3rem'}}>
            <h3 style={{color: 'var(--charcoal)', fontWeight: 600, marginBottom: '1rem', fontSize: '1.8rem'}}>
              💚 Emerald — $1,000 annually
            </h3>

            <p style={{fontWeight: '600', color: 'var(--charcoal)', marginBottom: '0.8rem'}}>All Sapphire benefits, plus:</p>
            <ul style={{marginLeft: '0', paddingLeft: '0', listStyle: 'none', color: '#666'}}>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Prominent logo placement</strong> on competition program distributed to 200+ attendees</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Logo on event signage</strong> at competition venue</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>2 dedicated social posts + stories</strong></li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>2 complimentary tickets</strong> to Prix du Canada competition</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Recognition during event</strong> announcements</li>
              <li style={{marginBottom: '0.6rem'}}>✓ Quarterly impact reports with photos and participant stories</li>
            </ul>
          </section>

          {/* RUBY TIER */}
          <section id="ruby" style={{marginBottom: '3rem'}}>
            <h3 style={{color: 'var(--charcoal)', fontWeight: 600, marginBottom: '1rem', fontSize: '1.8rem'}}>
              ❤️ Ruby — $2,000 annually
            </h3>

            <p style={{fontWeight: '600', color: 'var(--charcoal)', marginBottom: '0.8rem'}}>All Emerald benefits, plus:</p>
            <ul style={{marginLeft: '0', paddingLeft: '0', listStyle: 'none', color: '#666'}}>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Featured logo placement</strong> on website homepage and all competition materials</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>VIP reception</strong> with dancers, judges, and artistic staff</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>VIP seating</strong> reserved for your guests at competition</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>4 complimentary tickets</strong> to Prix du Canada competition</li>
              <li style={{marginBottom: '0.6rem'}}>✓ Recognition in all press releases and media coverage</li>
            </ul>
          </section>

          {/* DIAMOND TIER */}
          <section id="diamond" style={{marginBottom: '3rem'}}>
            <h3 style={{color: 'var(--charcoal)', fontWeight: 600, marginBottom: '1rem', fontSize: '1.8rem'}}>
              💎 Diamond — $3,500 annually
            </h3>

            <p style={{fontWeight: '600', color: 'var(--charcoal)', marginBottom: '0.8rem'}}>All Ruby benefits, plus:</p>
            <ul style={{marginLeft: '0', paddingLeft: '0', listStyle: 'none', color: '#666'}}>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Create a custom award</strong> in your company's name presented on stage during the competition</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Speaking opportunity</strong> at Prix du Canada to address attendees and dancers</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Directly sponsor underprivileged dancers</strong> — fund registration fees for talented dancers facing financial barriers and receive their stories</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Premier logo placement</strong> — largest size across all materials</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>8 complimentary VIP tickets</strong> with reserved seating</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Exclusive networking event</strong> with judges, artistic staff, and community leaders</li>
              <li style={{marginBottom: '0.6rem'}}>✓ <strong>Custom branded content opportunity</strong> — co-created stories, videos, or articles</li>
            </ul>

            <div style={{background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)', border: '2px solid #00A7E1', padding: '1.5rem', margin: '1.5rem 0', borderRadius: '8px', textAlign: 'center'}}>
              <p style={{margin: 0, fontWeight: '700', color: '#00A7E1', fontSize: '1.1rem', marginBottom: '0.5rem'}}>
                ✨ Diamond Sponsors: Create Your Legacy
              </p>
              <p style={{margin: 0, color: 'var(--soft-gray)'}}>
                Establish an award that celebrates excellence and directly supports the next generation of dancers — your company's name on stage at every Prix du Canada.
              </p>
            </div>
          </section>

          {/* PRESENTING PARTNER */}
          <section id="presenting" style={{marginBottom: '3rem'}}>
            <div style={{background: 'linear-gradient(135deg, var(--primary-gold), var(--deep-gold))', borderRadius: '14px', padding: '2.5rem', color: '#fff', textAlign: 'center', boxShadow: '0 6px 24px rgba(196,146,42,0.35)'}}>
              <div style={{fontSize: '2.5rem', marginBottom: '0.75rem'}}>🍁</div>
              <h2 style={{color: '#fff', fontFamily: "'Playfair Display', serif", fontSize: '1.8rem', marginBottom: '0.75rem'}}>
                Presenting Partner — Shape Canadian Ballet History
              </h2>
              <p style={{color: 'rgba(255,255,255,0.92)', fontSize: '1.05rem', maxWidth: '620px', margin: '0 auto 0.75rem'}}>
                As our Presenting Partner, your organization holds exclusive title naming rights — Prix du Canada becomes <em>"Prix du Canada, presented by [Your Company]"</em> across every asset, announcement, and press release.
              </p>
              <p style={{color: 'rgba(255,255,255,0.8)', fontSize: '0.95rem', maxWidth: '580px', margin: '0 auto 1.75rem'}}>
                This is a founding-level opportunity to be woven into the story of one of Canada's newest premier ballet competitions from day one.
              </p>
              <a href="#contact" style={{display: 'inline-block', background: '#fff', color: 'var(--deep-gold)', padding: '14px 36px', borderRadius: '8px', textDecoration: 'none', fontWeight: '700', fontSize: '1rem', boxShadow: '0 4px 12px rgba(0,0,0,0.15)'}}>
                Become a Sponsor
              </a>
            </div>

            {/* Presenting Partner benefits */}
            <div style={{marginTop: '2rem', padding: '0 0.5rem'}}>
              <h3 style={{color: 'var(--primary-gold)', fontWeight: 600, marginBottom: '0.5rem', fontSize: '1.8rem'}}>
                🍁 Presenting Partner — $5,000 annually
              </h3>
              <p style={{fontWeight: '600', color: 'var(--charcoal)', marginBottom: '0.8rem'}}>All Diamond benefits, plus:</p>
              <ul style={{marginLeft: '0', paddingLeft: '0', listStyle: 'none', color: '#666'}}>
                <li style={{marginBottom: '0.6rem'}}>✓ <strong>Exclusive title naming rights</strong> — "Prix du Canada, presented by [Your Company]" on all assets</li>
                <li style={{marginBottom: '0.6rem'}}>✓ <strong>First logo position</strong> on every single asset, material, and communication</li>
                <li style={{marginBottom: '0.6rem'}}>✓ <strong>Dedicated section</strong> on the website homepage</li>
                <li style={{marginBottom: '0.6rem'}}>✓ <strong>Company representative presents award on stage</strong> during the competition</li>
                <li style={{marginBottom: '0.6rem'}}>✓ <strong>Featured as presenting sponsor</strong> in all press releases and media outreach</li>
                <li style={{marginBottom: '0.6rem'}}>✓ <strong>Private reception</strong> with artistic director and judges</li>
              </ul>
            </div>
          </section>

          {/* All Tiers Include */}
          <section style={{marginBottom: '3rem', background: '#ffffff', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)'}}>
            <h3 style={{textAlign: 'center', color: 'var(--charcoal)', marginBottom: '1.5rem'}}>All Sponsorship Tiers Include</h3>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem'}}>
              <div>
                <p style={{fontWeight: '600', color: 'var(--primary-gold)', marginBottom: '0.5rem'}}>🎯 Brand Recognition</p>
                <p style={{color: '#666', fontSize: '0.95rem', margin: 0}}>Your logo and brand associated with excellence, inclusivity, and community impact</p>
              </div>
              <div>
                <p style={{fontWeight: '600', color: 'var(--primary-gold)', marginBottom: '0.5rem'}}>📜 Official Recognition</p>
                <p style={{color: '#666', fontSize: '0.95rem', margin: 0}}>Certificate of sponsorship for your full contribution amount</p>
              </div>
              <div>
                <p style={{fontWeight: '600', color: 'var(--primary-gold)', marginBottom: '0.5rem'}}>📊 Full Transparency</p>
                <p style={{color: '#666', fontSize: '0.95rem', margin: 0}}>Detailed reports showing exactly where your contribution goes and the impact you're making</p>
              </div>
              <div>
                <p style={{fontWeight: '600', color: 'var(--primary-gold)', marginBottom: '0.5rem'}}>🤝 Community Connection</p>
                <p style={{color: '#666', fontSize: '0.95rem', margin: 0}}>Direct engagement with Canada's vibrant ballet community and performing arts sector</p>
              </div>
            </div>
          </section>

          {/* Custom Partnerships Section */}
          <section style={{marginBottom: '3rem', background: 'linear-gradient(135deg, #fff9f0 0%, #faf9f7 100%)', padding: '2rem', borderRadius: '12px', border: '1px solid #e8d4b8'}}>
            <h3 style={{textAlign: 'center', color: 'var(--charcoal)', marginBottom: '1rem'}}>Custom Partnerships</h3>
            <p style={{textAlign: 'center', color: 'var(--soft-gray)', marginBottom: '1rem'}}>
              For multi-year commitments or contributions above $7,500, we're happy to create a fully custom partnership tailored to your organization's goals. Possibilities include multi-year naming rights, exclusive category sponsorship, and custom community programs.
            </p>
          </section>

          {/* Contact Section */}
          <section id="contact" style={{marginBottom: '2rem'}}>
            <h2 style={{textAlign: 'left', color: 'var(--charcoal)'}}>Become a Sponsor</h2>
            <p style={{marginBottom: '1rem'}}>
              We'd love to discuss how your organization can partner with Prix du Canada to support the Canadian ballet community and achieve your corporate social responsibility goals.
            </p>
            <div style={{background: '#ffffff', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', textAlign: 'center'}}>
              <p style={{fontSize: '1.1rem', color: 'var(--charcoal)', marginBottom: '1rem'}}>
                <strong>Contact us to explore sponsorship opportunities:</strong>
              </p>
              <p style={{marginBottom: '0.5rem'}}>
                <a href="mailto:info@prixducanada.com" style={{color: 'var(--primary-gold)', fontSize: '1.2rem', fontWeight: '600', textDecoration: 'none'}}>
                  info@prixducanada.com
                </a>
              </p>
              <p style={{color: 'var(--soft-gray)', fontSize: '0.95rem', marginBottom: '1.5rem'}}>
                We typically respond within 24-48 hours
              </p>
              <Link
                to="/contact"
                style={{
                  display: 'inline-block',
                  background: 'linear-gradient(135deg, #d4a574 0%, #c49563 100%)',
                  color: '#ffffff',
                  padding: '14px 32px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '1rem',
                  boxShadow: '0 4px 12px rgba(212, 165, 116, 0.3)',
                  transition: 'transform 0.2s'
                }}
              >
                Become a Sponsor
              </Link>
            </div>
          </section>

          {/* Why Partner Reason Blocks */}
          <section style={{marginBottom: '3rem', paddingTop: '2rem', borderTop: '1px solid #e0e0e0'}}>
            <h3 style={{textAlign: 'center', color: 'var(--charcoal)', marginBottom: '1.5rem'}}>Why Partner with Prix du Canada</h3>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem'}}>
              <div style={{textAlign: 'center'}}>
                <img src={iconFirst} alt="Inaugural Year" style={{width: '64px', height: '64px', objectFit: 'contain', marginBottom: '0.75rem'}} />
                <h4 style={{color: 'var(--charcoal)', marginBottom: '0.5rem'}}>Inaugural Year</h4>
                <p style={{color: '#666', fontSize: '0.95rem', margin: '0 auto', textAlign: 'center'}}>
                  Be a founding sponsor of Canada's newest premier ballet competition
                </p>
              </div>
              <div style={{textAlign: 'center'}}>
                <img src={iconInclusive} alt="Inclusive Mission" style={{width: '64px', height: '64px', objectFit: 'contain', marginBottom: '0.75rem'}} />
                <h4 style={{color: 'var(--charcoal)', marginBottom: '0.5rem'}}>Inclusive Mission</h4>
                <p style={{color: '#666', fontSize: '0.95rem', margin: '0 auto', textAlign: 'center'}}>
                  Support a competition that welcomes competitive, recreational, and adult dancers
                </p>
              </div>
              <div style={{textAlign: 'center'}}>
                <img src={iconProfessional} alt="Professional Quality" style={{width: '64px', height: '64px', objectFit: 'contain', marginBottom: '0.75rem'}} />
                <h4 style={{color: 'var(--charcoal)', marginBottom: '0.5rem'}}>Professional Quality</h4>
                <p style={{color: '#666', fontSize: '0.95rem', margin: '0 auto', textAlign: 'center'}}>
                  World-class production values, professional venue, and exceptional artistic standards
                </p>
              </div>
            </div>
          </section>

          {/* Footer Note */}
          <div style={{textAlign: 'center', paddingTop: '2rem', borderTop: '1px solid #e0e0e0', color: 'var(--soft-gray)', fontSize: '0.9rem'}}>
            <p style={{marginBottom: '0.5rem'}}>
              Questions about corporate sponsorship? <Link to="/contact" style={{color: 'var(--primary-gold)', textDecoration: 'underline'}}>Contact us</Link> and we'll be happy to help!
            </p>
            <p style={{margin: 0, fontSize: '0.85rem', color: '#999'}}>
              Page last updated: March 2026
            </p>
          </div>

        </div>
      </section>
    </Layout>
  );
};

export default CorporateSponsorship;
